<template>
  <div
    class="slide-control-block"
    :class="{'share':sharePresentation}"
    v-show="slideArrowVisible"
  >
    <div class="slide-control slide-arrow-left">
      <button :disabled="!prevSlideArrowVisible" @click="prevSlide()">
        <i class="fas fa-chevron-left" />
      </button>
    </div>
    <span id="slide-input">{{ getCurrentPage() }}</span>
    <div class="slide-control slide-arrow-right">
      <button :disabled="!nextSlideArrowVisible" @click="nextSlide()">
        <i class="fas fa-chevron-right" />
      </button>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'

export default {
  props: {
    shareView: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      currentPage: 0,
      hasPrevSlide: false,
      hasNextSlide: true,
    }
  },
  computed: {
    ...mapState({
      isScreenCapture: (state) => state.isScreenCapture,
      presentation: (state) => state.presentation,
      sharePresentation: (state) => state.sharePresentation,
    }),
    ...mapGetters(['isPresenting']),
    slideArrowVisible() {
      return this.isPresenting && !this.isScreenCapture
    },
    prevSlideArrowVisible() {
      return this.currentPage > 0
    },
    nextSlideArrowVisible() {
      return this.presentation.slides && (
        this.$store.getters.currentSlideIndex <
        this.presentation.slides.length - 1
      )
    },
  },
  methods: {
    prevSlide() {
      this.$emit('selectPrevSlide', 'icon-arrow-left')
    },

    nextSlide() {
      this.$emit('selectNextSlide', 'icon-arrow-right')
    },

    getCurrentPage() {
      if (this.$store.getters.currentSlideIndex >= 0) this.currentPage = this.$store.getters.currentSlideIndex
      return this.currentPage + 1
    },
  },
}
</script>

<style lang="scss" scoped>
.slide-control-block {
  display: flex;
  font-size: 14px;
  padding: 0 0.5rem;
  position: relative;
  align-items: center;

  &:after {
    width: 1px;
    content: "";
    right: -1px;
    height: 24px;
    position: absolute;
    background-color: #D3D7E1;
    transition: background-color 0.2s ease-out;
  }
  &.share {
    padding: 0;

    &:after {
      width: 0;
    }
  }
}
#slide-input {
  border: 1px solid #D3D7E1;
  width: 45px;
  height: 28px;
  display: flex;
  font-size: 16px;
  font-weight: bold;
  border-radius: 5px;
  align-items: center;
  justify-content: center;
}
.slide-control {
  cursor: pointer;
  position: relative;

  > button {
    height: 40px;
    width: 2rem;
    display: flex;
    align-items: center;
    justify-content: center;

    &:disabled {
      opacity: 0.5;
      cursor: default;
      color: #D3D7E1;
    }
    &:focus {
      outline: none;
    }

    &:not(:disabled):after {
      top: 8px;
      z-index: -1;
      content: "";
      width: 24px;
      height: 24px;
      border-radius: 50%;
      position: absolute;
      transition: all 0.3s ease;
    }
    &:hover {
      &:after {
        background-color: #ebebeb;
      }
    }
  }
  &.slide-arrow-left > button {
    &:after {
      left: 4px;
    }
  }
  &.slide-arrow-right > button {
    &:after {
      left: 3px;
    }
  }
}
.white {

  > .slide-control-block {

    &:after {
      background-color: rgba(255, 255, 255, 0.2);
    }
    #slide-input {
      color: #fff;
      border-color: rgba(255, 255, 255, 0.2);
      background-color: rgba(255, 255, 255, 0.2);
    }

    > .slide-control > button {
      &:hover {
        &:after {
          background-color: rgba(211, 215, 225, 0.2);
        }
      }
    }
  }
}

</style>
